export const BankFeedConnectionStatus = {
    CONNECTED: 'CONNECTED',
    PENDING: 'PENDING',
    NOT_CONNECTED: 'NOT_CONNECTED',
};
